// Modal component styled for mfe
import React from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';

import Modal from 'zignal-landscape/lib/Modal';
import Remove1Icon from 'zignal-landscape/lib/Icon/Remove1Icon';

const MfeModal = ({ styles, children, onClose, title, ...modalProps }) => {
  return (
    <Modal {...modalProps}>
      { title ? (
        <div className={styles.MfeModal}>
          <div className={styles.modalHeader}>
            <div className={styles.modalTitle}>{title}</div>
            { onClose && <div className={styles.modalCancel}><Remove1Icon onClick={onClose} /></div> }
          </div>
          {children}
        </div>
      ) : children }
    </Modal>
  );
};

MfeModal.propTypes = {
  styles: PropTypes.object.isRequired,
  children: PropTypes.node,
  title: PropTypes.string,
  onClose: PropTypes.func
};

export default themeable(MfeModal);
